"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicTimeoutModalComponent = void 0;
const core_1 = require("@angular/core");
const angular2_modal_1 = require("angular2-modal");
let DynamicTimeoutModalComponent = class DynamicTimeoutModalComponent {
    constructor(dialog) {
        this.dialog = dialog;
    }
    cancel() {
        this.dialog.close();
    }
};
exports.DynamicTimeoutModalComponent = DynamicTimeoutModalComponent;
exports.DynamicTimeoutModalComponent = DynamicTimeoutModalComponent = __decorate([
    (0, core_1.Component)({
        selector: 'dynamic-timeout-modal',
        styleUrls: [],
        template: `
    <div class="modal fade in" tabindex="-1" style="display:block">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
    
                <div class="modal-header">
                    <button type="button" class="close" (click)="cancel()">&times;</button>
                    <h4 class="modal-title">Timeout</h4>
                </div>
    
                <div class="modal-body bottomMargin15">
                    <div class="row bottomMargin30">
                        <div class="col-xs-12">
                            The Timeout feature allows you to set custom timeouts based on the detected connection bandwidth of an end-user. Your Minimum Timeout must be 100ms or greater, and your Maximum Timeout has a cap of 60000ms. The Minimum Timeout range will activate if a user is detected on a bandwidth connection that is greater than or equal to your Fast Bandwidth cutoff. And your Maximum Timeout range will activate when it reaches below the end-user connection detected is below the fast bandwidth cutoff.
                        </div>
                    </div>
    
                    <table class="table table-striped row">
                        <tr>
                            <th class="bold col-xs-3">Connection Type</th>
                            <th class="bold col-xs-6">Description</th>
                            <th class="bold col-xs-3">Speed</th>
												</tr>
												<tr>
														<td class="col-xs-3">GPRS</td>
														<td class="col-xs-6">General Packet Radio Service bandwidth will generally be detected in end-users that are using devices on a cellular network.</td>
														<td class="bold col-xs-3">.050 mbps</td>
												</tr>
												<tr>
														<td class="col-xs-3">2G</td>
														<td class="col-xs-6">2G is another form of cellular technology detected within an end-user</td>
														<td class="bold col-xs-3">.25-45 mbps</td>
												</tr>
												<tr>
														<td class="col-xs-3">3G</td>
														<td class="col-xs-6">3G is a form of cellular technology detected within an end-user</td>
														<td class="bold col-xs-3">.75 mbps - 1.5 mbps</td>
												</tr>
												<tr>
														<td class="col-xs-3">4G</td>
														<td class="col-xs-6">4G is the fourth generation of cellular technology and end-users on this connection speed can likely be streaming video, amongst other data intensive applications across various device types</td>
														<td class="bold col-xs-3">4 mbps</td>
												</tr>
												<tr>
														<td class="col-xs-3">Wi-Fi</td>
														<td class="col-xs-6">This instance of Wi-Fi is your standard Wi-Fi speed that provides the bandwidth for users who are using various device types to casually surf the web and check email, with some support for the video streaming and downloads</td>
														<td class="bold col-xs-3">2-10 mbps</td>
												</tr>
												<tr>
														<td class="col-xs-3">High Speed Wi-Fi</td>
														<td class="col-xs-6">This instance of Wi-Fi provides the highest speeds in web surfing across all device types. This can support the streaming of high-def video content and make fast downloads. At the top thresholds of this Wi-Fi, users can simultaneously run various applications at once</td>
														<td class="bold col-xs-3">10+ mbps</td>
												</tr>
										</table>
                </div>
    
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="cancel()">Ok</button>
                </div>
            </div>
        </div>
    </div>
`
    }),
    __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
], DynamicTimeoutModalComponent);
//# sourceMappingURL=dynamic-timeout-modal.component.js.map